import React, { useEffect, useState } from 'react';
import { Form, message } from 'antd';
import { premiumpassApi } from 'apis/sales/premiumpassApis';
import SmallModal from 'components/form/SmallModal';
import VerticalForm from 'components/form/DefaultForm';
import DefaultRadio from 'components/input/DefaultRadio';
import DefaultInput from 'components/input/DefaultInput';
import SubmitButton from 'components/button/SubmitButton';
import { useTranslation } from 'react-i18next';

const PremiumPassInputModal = ({ visible, setVisible, record, fetchData }) => {
  const { t } = useTranslation();
  const [inputData, setInputData] = useState({
    timedeal_id: 0,
    conditions: 0,
    discount: null,
    deadline: null,
    episode_progress: null,
  }); //초기값(등록일 때 적용)

  const timeDealCondi = [
    {
      key: 0,
      value: 0,
      text: t('premium.registerPremiumModal.episodeProgressCondition'),
    },
    {
      key: 1,
      value: 1,
      text: t('premium.registerPremiumModal.hiddenEndingCondition'),
    },
  ];

  ///모달 닫기
  const handleClose = () => {
    setVisible(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };

  const handleSubmit = async () => {
    const res = await premiumpassApi.registerPremium(inputData);
    if (!res) {
      return false;
    }
    fetchData();
    handleClose();
    message.success(
      `프리미엄 패스 ${record ? '수정' : '등록'}을 완료 했습니다.`,
    );
  };

  const fetchInputData = async () => {
    setInputData(record);
  };

  useEffect(() => {
    if (record) {
      fetchInputData().catch(console.log);
    }
  }, [visible]);

  return (
    <SmallModal
      footer={
        <SubmitButton onClick={handleSubmit}>
          {record
            ? t('premium.registerPremiumModal.editButton')
            : t('premium.registerPremiumModal.registerButton')}
        </SubmitButton>
      }
      title={
        record
          ? t('premium.registerPremiumModal.titleUpdateModal')
          : t('premium.registerPremiumModal.titleRegisterModal')
      }
      visible={visible}
      onCancel={handleClose}
    >
      {/* 타임딜ID */}
      {record && ''}
      <VerticalForm>
        <Form.Item label={t('premium.registerPremiumModal.condition')}>
          <DefaultRadio
            name='conditions'
            optionList={timeDealCondi}
            onChange={handleInputChange}
            defaultValue={inputData.conditions}
          />
        </Form.Item>
        <Form.Item label={t('premium.registerPremiumModal.episodeProgress')}>
          <DefaultInput
            name='episode_progress'
            type='number'
            onChange={handleInputChange}
            value={inputData.episode_progress}
          />
        </Form.Item>
        <Form.Item label={t('premium.registerPremiumModal.discount')}>
          <DefaultInput
            name='discount'
            type='number'
            onChange={handleInputChange}
            value={inputData.discount}
          />
        </Form.Item>
        <Form.Item label={t('premium.registerPremiumModal.deadline')}>
          <DefaultInput
            name='deadline'
            type='number'
            onChange={handleInputChange}
            value={inputData.deadline}
          />
        </Form.Item>
      </VerticalForm>
    </SmallModal>
  );
};

export default PremiumPassInputModal;
